<form *ngIf="rateTemplateLineFormGroup" [formGroup]="rateTemplateLineFormGroup">
    <div class="grid">
        <div class="col-10 input-field">
            <label for="rateLineId">Línea de baremo</label>
            <p-dropdown formControlName="rateLineId" [options]="rateLines" optionLabel="displayName" optionValue="id"
                appendTo="body" [filter]="true" filterBy="code" placeholder="Selecciona una línea de baremo"
                d-form-field-error></p-dropdown>
        </div>
        <div class="col-2 input-field">
            <label for="quantity">Cantidad</label>
            <input formControlName="quantity" pInputText type="number" d-form-field-error>
        </div>
        <div class="col-12 input-field">
            <label for="description">Descripción adicional</label>
            <textarea pInputTextarea formControlName="description" style="field-sizing: content;"
                d-form-field-error></textarea>
        </div>
    </div>
    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete && rateTemplateId" icon="pi pi-trash" styleClass="p-button-danger"
            (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>
</form>